import React, { useState } from "react";
import Modal from "react-modal";
import { AiFillCloseCircle } from "react-icons/ai";

const ModalGetDocument = ({
  isModaOpen,
  setIsModalOpen,
  cardSelected,
  docTypeSelected,
  setDocumentTypeSelected,
  studentIdSelected,
}) => {
  const [studentDetail, setStudentDetail] = useState({ id: 0 });
  const [studentIdInput, setStudentIdInput] = useState("");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      // height: "100%",
      minHeight: "300px",
      maxHeight: "90vh",
      maxWidth: "90vw",
      minWidth: "500px",
      // width: "100%",
      overflowY: "auto",
      padding: "10px",
    },
    overlay: { zIndex: 3000 },
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onSubmitCheckStudent = (ev) => {
    ev.preventDefault();
    const getStudentDetail = cardSelected.internStd.find(
      (st) => st.st_id == studentIdInput
    );

    setStudentDetail(getStudentDetail ?? { id: 0, name: "ไม่พบข้อมูล" });
  };

  const displayContent = (
    <div className="p-4">
      <form onSubmit={onSubmitCheckStudent}>
        <h4 className="my-2">Doc ID : {cardSelected?.idm_doc_id}</h4>
        <div className="input-group mb-3">
          <input
            className="form-control"
            type="number"
            onChange={(ev) => {
              setStudentIdInput(ev.target.value);

              setStudentDetail({ id: 0 });
            }}
            value={studentIdInput}
          />

          <button type="submit" className="btn btn-outline-secondary">
            Check
          </button>
        </div>
      </form>
      <div>
        {studentDetail?.internStudent?.name
          ? `คนที่มารับ ${studentDetail?.internStudent?.name}`
          : ""}
      </div>
      <form action="./update-status-get-document.php" method="post">
        <input value={studentIdInput} className="d-none" name="user" />
        {cardSelected?.internStd?.length &&
          cardSelected?.internStd?.map((st, stIndex) => {
            return (
              <input name="st_id[]" value={st?.st_id} className="d-none" />
            );
          })}
        <input
          name="req_id"
          value={cardSelected?.idm_doc_id}
          className="d-none"
        />
        <input className="d-none" value={docTypeSelected} name="doc_type" />
        <button
          type="submit"
          onClick={() => {
            setDocumentTypeSelected(2);
          }}
          className="btn btn-primary"
          disabled={studentDetail && studentDetail.id == 0 ? true : false}
        >
          ยืนยัน
        </button>
      </form>
    </div>
  );

  return (
    <Modal isOpen={isModaOpen} onRequestClose={closeModal} style={customStyles}>
      <div className=" d-flex justify-content-between align-items-center bg-white">
        <h3>การรับหนังสือขอความอนุเคราะห์ฝึกงาน/ สหกิจศึกษา</h3>

        <AiFillCloseCircle
          size="2rem"
          color="#CE3B46"
          onClick={closeModal}
          role="button"
        />
      </div>
      {displayContent}
    </Modal>
  );
};

export default ModalGetDocument;
